import React, { useState, useEffect } from 'react';
import {
    makeStyles,
    withStyles,
    Typography,
    Slide as MUISlide,
    Dialog,
    IconButton,
    DialogContent,
    DialogActions,
    Button,
    DialogTitle,
    Divider,
    DialogContentText,
    Card,
    CardContent,
    FormHelperText,
    Collapse,
    Menu,
    MenuList,
    ClickAwayListener,
    Grow,
    Popper,
    InputAdornment,
    MenuItem,
    Grid,
    InputLabel,
    Input
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Switches,
    Autocomplete
} from 'mui-rff';
import { Form, Field } from 'react-final-form';
import * as logger from '../../../logger';
import { numberWithCommas, replaceCommas, checkNumberOnly, getDateInStringDocumentDDMMMYYYY } from '../../../utils/utils';
import { connect } from "react-redux";
import { emiDate, FetchExpenseDetails, singleTruck, UpdateExpenseDetails } from '../../../store/actions/vehicleActionCreator';
import { addPastPaymentCss as useStyles } from './VehicleDialogCss';
import DateFnsUtils from '@date-io/date-fns';
import { addVendorExpense } from "../../../store/actions/tripActionCreator";
import AmountInput from '../Inputs/AmountInput';
import { trackDwebEvent } from '../../analytics';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';


const AddPastPayment = ({ open, onClose, vehicle, onConfirm, vehicleIdValue, user, expenseId, edit, dispatchUpdateExpenseDetails, dispatchGetEmiSelectDate, dispacthAddExpenses, dispatchFetchSingleExpense }) => {

    let submit;
    const [dialogOpen, setDialogOpen] = useState(false);
    const [pastPaymentDetails, setPastPaymentDetails] = useState({ emiDates: [] });
    const [expenseDetails, setExpenseDetails] = useState({});
    const [emiAmount, setEmiAmount] = useState("");

    const classes = useStyles();

    let singleTruck = vehicle && vehicle.singleTruck ? vehicle.singleTruck : ""

    useEffect(() => {
        dispatchGetEmiSelectDate(Number(vehicleIdValue),
            (data) => {
                if (data.status && data.status.code == 200) {
                    logger.log("Add Past Payment", "Get EMI date successfull");

                    if (edit) {
                        dispatchFetchSingleExpense(expenseId,
                            (data) => {
                                if (data && data.status && data.status.code == 200) {
                                    logger.log("EMI Book", "Fetch single expense successfull");
                                    setDialogOpen(true);
                                }
                            },
                            () => {
                                logger.log("EMI Book", "Fetch single expense failed");
                            }
                        );
                    } else {
                        setDialogOpen(true);
                    }

                }
            },
            () => {
                logger.log("Add Past Payment", "Get EMI date failed");
            }
        );


    }, [open]);

    useEffect(() => {

        if (vehicle.emiSelectDate) {
            setPastPaymentDetails(vehicle.emiSelectDate);
        }

    }, [vehicle.emiSelectDate, pastPaymentDetails]);

    useEffect(() => {

        if (edit && vehicle.singleExpenseDetails) {
            setExpenseDetails(vehicle.singleExpenseDetails);
            pastPaymentDetails.emiDates.push({ date: vehicle.singleExpenseDetails.emiDate ? vehicle.singleExpenseDetails.emiDate : "" });
        }

    }, [vehicle.singleExpenseDetails]);

    const initialValues = {
        dueOn: edit && expenseDetails.emiDate ? expenseDetails.emiDate : pastPaymentDetails && pastPaymentDetails.defaultValue ? pastPaymentDetails.defaultValue : "",
        amount: emiAmount ? emiAmount : edit && expenseDetails.amount ? numberWithCommas(expenseDetails.amount) : vehicle && vehicle.truckBooks && vehicle.truckBooks.emiAmount ? numberWithCommas(vehicle.truckBooks.emiAmount) : "",
        paymentDate: edit && expenseDetails.expenseDate ? new Date(expenseDetails.expenseDate * 1000) : pastPaymentDetails && pastPaymentDetails.defaultValue ? new Date(pastPaymentDetails.defaultValue * 1000) : "",
    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.divSelect}>
                            <div className={classes.title}>Due on</div>
                            {pastPaymentDetails && pastPaymentDetails.emiDates && pastPaymentDetails.emiDates.length > 0 &&
                                <>
                                    <Select
                                        name="dueOn"
                                        variant="outlined"
                                        notched
                                        formControlProps={{ margin: 'none', size: "small", fullWidth: false, labelWidth: 0 }}
                                        className={classes.selectV1}
                                        fieldProps={{
                                            endAdornment: <InputAdornment position="end">of every month</InputAdornment>
                                        }}
                                    >
                                        {pastPaymentDetails && pastPaymentDetails.emiDates && pastPaymentDetails.emiDates.length > 0 && pastPaymentDetails.emiDates.map((date) => (
                                            (edit ?
                                                <MenuItem key={date.date} value={date.date} className={date.date == expenseDetails.emiDate ? classes.menuItemV1 : ""} >{getDateInStringDocumentDDMMMYYYY(date.date)}</MenuItem>
                                                :
                                                <MenuItem key={date.date} value={date.date}>{getDateInStringDocumentDDMMMYYYY(date.date)}</MenuItem>
                                            )))}
                                    </Select>
                                </>
                            }
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.marginV2}>
                            <div className={classes.title}>Amount Paid</div>
                            <AmountInput
                                placeholder="Amount Paid"
                                name="amount"
                                variant="outlined"
                                size="small"
                                onChange={(e) => setEmiAmount(e.target.value)}
                                fieldProps={{
                                    // parse: value => value && numberWithCommas(value)
                                }}
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">&#x20b9;</InputAdornment>
                                }}
                                className={classes.marginV1}
                            />
                        </div>
                    </>
                )
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.marginV2}>
                        <div className={classes.title}>Payment Date</div>
                        <DatePicker
                            disableFuture
                            name="paymentDate"
                            margin="none"
                            variant="inline"
                            fullWidth={true}
                            inputVariant="outlined"
                            size="small"
                            format="dd MMM yyyy"
                            placeholder="Payment Date"
                            dateFunsUtils={DateFnsUtils}
                            required={true}
                            className={classes.marginV1}
                            InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={classes.eventIcon}></EventOutlinedIcon></InputAdornment> }}
                        />
                    </div>
                )
            }
        ]
    }

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const validate = values => {

        const errors = {}

        if (!values.amount || !checkNumberOnly(replaceCommas(values.amount))) {
            errors.amount = "Please enter valid amount."
        }

        return errors;

    }

    const onSubmit = values => {

        var data = {
            vehicleId: Number(vehicleIdValue),
            amount: replaceCommas(values.amount),
            expenseParentType: "emi",
            fleetOwnerId: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : "",
            expenseDate: values.paymentDate ? Number(Math.round((values.paymentDate.setHours(0, 0, 0, 0) / 1000))) : "",
            emiDate: values.dueOn,
        }

        if (edit) {

            dispatchUpdateExpenseDetails(
                expenseDetails.id,
                data,
                (data) => {
                    if (data.status && data.status.code == 200) {
                        logger.log("Add Past Payment", "Add expense successfull");
                        setDialogOpen(false);
                        onConfirm();
                    }
                },
                () => {
                    logger.log("Add Past Payment", "Add expense failed");
                }
            );

        } else {

            dispacthAddExpenses(data,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        trackDwebEvent("Dweb SVP EMI Past Payment Created Successfully", {
                            vehicle_id: singleTruck && singleTruck.id ? singleTruck.id : "",
                            vehicle_number: singleTruck && singleTruck.vehicleNumber ? singleTruck.vehicleNumber : "",
                            emi_amount: values && values.amount ? values.amount : "",
                            emi_payment_date: values && values.paymentDate ? values.paymentDate : "",
                            emi_id: data && data.response && data.response.emiId ? data.response.emiId : "",
                            emi_due_date: values && values.dueOn ? new Date(values.dueOn * 1000) : "",
                        });
                        logger.log("Add Past Payment", "Add payment successfull");
                        setDialogOpen(false);
                        onConfirm();
                    }
                },
                () => {
                    logger.log("Add Past Payment", "Add payment failed");
                }
            );
        }

    }

    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='sm'
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-driver-dialog-title" open={dialogOpen} classes={{ paper: classes.paper2, paperWidthSm: classes.paperWidth }}>
                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divV1}>{edit ? "Edit Past Payment" : "Add Past Payment"}</div>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Form
                        onSubmit={onSubmit}
                        keepDirtyOnReinitialize
                        initialValues={initialValues}
                        validate={validate}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit
                            return (
                                <form onSubmit={handleSubmit} noValidate id="myForm">
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />
                </DialogContent>
                <Divider className={classes.marginV3} />
                <DialogActions className={classes.da1}>
                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()} >
                        Close
                    </Button>
                    <Button className={classes.confirmV1} type="submit" variant="contained"
                        onClick={event => {
                            submit(event)
                        }}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );

}

const mapStateToProps = (state) => ({ user: state.user, vehicle: state.vehicle });
const mapDispatchToProps = (dispatch) => ({
    dispatchGetEmiSelectDate: (vehicleId, onSuccess, onFailure) => dispatch(emiDate(vehicleId, onSuccess, onFailure)),
    dispacthAddExpenses: (data, onSuccess, onFailure) => dispatch(addVendorExpense(data, onSuccess, onFailure)),
    dispatchFetchSingleExpense: (expenseId, onSuccess, onFailure) => dispatch(FetchExpenseDetails(expenseId, onSuccess, onFailure)),
    dispatchUpdateExpenseDetails: (expenseId, data, onSuccess, onFailure) => dispatch(UpdateExpenseDetails(expenseId, data, onSuccess, onFailure)),

});
export default connect(mapStateToProps, mapDispatchToProps)(AddPastPayment);